/**
 * CU Image Banner — gummy entrance (elastic scale) + infinite float (yoyo yPercent).
 * Content image: infinite right-left sway (rotation yoyo).
 * GSAP comes from assets/cu-window.js via {% render 'cu-theme-global' %} in the theme layout.
 */
(function () {
  function loadGsap() {
    if (window.CU && typeof window.CU.loadGsap === 'function') {
      return window.CU.loadGsap();
    }
    if (window.gsap) {
      return Promise.resolve(window.gsap);
    }
    return Promise.reject(
      new Error(
        'CU Image Banner: add {% render "cu-theme-global" %} in theme.liquid (loads cu-window.js + GSAP).'
      )
    );
  }

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function initCuImageBanner(root) {
    if (!root || root.dataset.cuImageBannerReady === 'true') {
      return;
    }

    if (prefersReducedMotion()) {
      root.dataset.cuImageBannerReady = 'true';
      return;
    }

    loadGsap()
      .then(function (gsap) {
        if (!root.isConnected) {
          return;
        }

        if (root._cuImageBannerCtx) {
          root._cuImageBannerCtx.revert();
          root._cuImageBannerCtx = null;
        }

        var ctx = gsap.context(function () {
          var defaults = { transformOrigin: '50% 50%' };

          gsap
            .timeline({ defaults: defaults })

            // ── Entrance: faster elastic scale pop-in, tightly staggered ──
            .from('.gummy-float--left-top', {
              scale: 0,
              duration: 1.2,
              ease: 'elastic.out(1, 0.5)',
            })
            .from('.gummy-float--left-bottom', {
              scale: 0,
              duration: 1.2,
              ease: 'elastic.out(1, 0.5)',
              delay: -1.0,
            })
            .from('.gummy-float--right-top', {
              scale: 0,
              duration: 1.2,
              ease: 'elastic.out(1, 0.5)',
              delay: -1.0,
            })
            .from('.gummy-float--right-bottom', {
              scale: 0,
              duration: 1.2,
              ease: 'elastic.out(1, 0.5)',
              delay: -1.0,
            })

            // ── Infinite float: faster yoyo, each offset so they don't sync ──
            .from('.gummy-float--left-top', {
              yPercent: 8,
              duration: 0.8,
              ease: 'power1.inOut',
              yoyo: true,
              repeat: -1,
              delay: -1.0,
            })
            .from('.gummy-float--left-bottom', {
              yPercent: 8,
              duration: 0.8,
              ease: 'power1.inOut',
              yoyo: true,
              repeat: -1,
              delay: -1.6,
            })
            .from('.gummy-float--right-top', {
              yPercent: 8,
              duration: 0.8,
              ease: 'power1.inOut',
              yoyo: true,
              repeat: -1,
              delay: -0.8,
            })
            .from('.gummy-float--right-bottom', {
              yPercent: 8,
              duration: 0.8,
              ease: 'power1.inOut',
              yoyo: true,
              repeat: -1,
              delay: -1.3,
            });

          // ── Content image: infinite right-left sway (rotation only) ──
          // Image apni jagah par khadi rahegi, sirf left-right jhukegi
          var contentImg = root.querySelector('.banner__content-image img');
          if (contentImg) {
            gsap.to(contentImg, {
              rotation: 8,           // +4 degree right jhukao
              duration: 1.2,
              ease: 'sine.inOut',
              yoyo: true,
              repeat: -1,
              transformOrigin: '50% 100%', // neeche se pivot — realistic sway
            });
          }
        }, root);

        root._cuImageBannerCtx = ctx;
        root.dataset.cuImageBannerReady = 'true';
      })
      .catch(function () {
        /* GSAP failed to load — leave elements static */
      });
  }

  function destroyCuImageBanner(root) {
    if (!root) {
      return;
    }
    if (root._cuImageBannerCtx) {
      root._cuImageBannerCtx.revert();
      root._cuImageBannerCtx = null;
    }
    delete root.dataset.cuImageBannerReady;
  }

  function scanAndInit(container) {
    var scope = container || document;
    var nodes = scope.querySelectorAll('[data-cu-image-banner-root]');
    for (var i = 0; i < nodes.length; i++) {
      initCuImageBanner(nodes[i]);
    }
  }

  function registerGlobalListenersOnce() {
    if (window.__cuImageBannerListeners) {
      return;
    }
    window.__cuImageBannerListeners = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scanAndInit();
      });
    }

    document.addEventListener('shopify:section:load', function (event) {
      scanAndInit(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var roots = event.target.querySelectorAll('[data-cu-image-banner-root]');
      for (var i = 0; i < roots.length; i++) {
        destroyCuImageBanner(roots[i]);
      }
    });
  }

  registerGlobalListenersOnce();
  scanAndInit();
})();